
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/report/cyclone",
      function () {
        return require("private-next-pages/report/cyclone.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/report/cyclone"])
      });
    }
  